import pick from 'ramda/src/pick';
import pipe from 'ramda/src/pipe';
import sum from 'ramda/src/sum';
import map from 'ramda/src/map';
import values from 'ramda/src/values';
const hmarginFields = ['marginLeft', 'marginRight'];
const hspacingFields = ['borderLeftWidth', 'borderRightWidth', 'paddingLeft', 'paddingRight', ...hmarginFields];

function toNumber(value) {
  if (typeof value === 'number') {
    return value;
  }

  return 0;
}

export const getHorizontalMargins = pipe(pick(hmarginFields), values, map(toNumber), sum);
export const getHorizontalSpacing = pipe(pick(hspacingFields), values, map(toNumber), sum);
//# sourceMappingURL=measure.js.map